module.exports = __webpack_public_path__ + "img/prize.6af2ecb2.png";